module.exports = fox._r("components/valentines-gifts-popup/fonts/arvo-bold-webfont.ttf", __webpack_public_path__ + "_/_/_/root/components/valentines-gifts-popup/fonts/1ndb6ip.ttf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/components/valentines-gifts-popup/fonts/arvo-bold-webfont.ttf
// module id = 726
// module chunks = 4